export function getFormalizationUrl(
  id: string,
  slug: string = "GranaTech"
): string {
  const isNode =
    typeof process !== "undefined" && process.env && process.env.VITE_ENV;
  const env = isNode ? process.env.VITE_ENV : import.meta.env.VITE_ENV;

  let baseUrl =
    env === "local"
      ? "https://dev.minhabiometria.com.br"
      : "https://v2.minhabiometria.com.br";

  if (slug !== "GranaTech") baseUrl = `https://${slug}.minhabiometria.com.br`;

  return `${baseUrl}/${id}`;
}
